<template>
  <v-container fill-height fluid grid-list-xl class="pt-0">
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card
          color="green"
          class="grid-card"
          v-bind:class="{ 'hide-header': hideHeader }"
        >
          <v-flex slot="header" v-if="title">
            <v-layout row>
              <span
                class="title font-weight-light mb-0"
                style="align-self: center"
                >{{ getTitle() }}</span
              >
              <v-spacer></v-spacer>
              <span
                class="title font-weight-light mb-0"
                style="align-self: center"
                v-html="getCustomTitleText()"
              ></span>
            </v-layout>
          </v-flex>
          <div v-if="showGrid">
            <div v-if="dataSource.isLoading()">
              {{ startLoading() }}
            </div>
            <div v-if="dataSource.isLoaded()">
              {{ finishLoading() }}
            </div>
            <DxDataGrid
              v-bind:class="{
                'dxgrid-clickable': navigationPath,
                'freeze-header': pinHeader,
              }"
              class="mt-3 dxgrid-custom"
              :data-source="dataSource"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              column-resizing-mode="nextColumn"
              :column-min-width="50"
              :on-row-click="onRowClick"
              :on-cell-click="onCellClick"
              :on-content-ready="onGridLoaded"
              :column-auto-width="true"
              :customize-export-data="customizeExportData"
              @toolbar-preparing="onToolbarPreparing($event)"
              :on-cell-prepared="runOnCellPrepared"
              @initialized="saveGridInstance"
              @selection-changed="onSelectionChanged"
              :on-exporting="onExporting"
              :on-exported="onExported"
              :on-row-updating="onRowUpdating"
              :on-row-removing="onRowRemoving"
              ref="grid"
            >
              <!-- :filter-builder="filterBuilder"
                            :filter-value="filterValue" -->

              <DxLoadPanel :enabled="false"> </DxLoadPanel>
              <DxExport
                v-if="allowExporting()"
                :enabled="true"
                :allow-export-selected-data="true"
                :file-name="title"
              />
              <DxPaging :page-size="20" />
              <!-- <DxRemoteOperations
                                :paging="true"
                            ></DxRemoteOperations> -->
              <DxRemoteOperations
                :filtering="true"
                :paging="isRemotePaging"
                :sorting="isRemoteSorting"
                :summary="false"
                :grouping="false"
                :group-paging="true"
              />
              <DxPager
                :show-page-size-selector="true"
                :allowed-page-sizes="pageSizes"
                :show-info="true"
              />
              <DxFilterRow :visible="true" />
              <DxStateStoring
                :enabled="!disableStoring"
                type="custom"
                storage-key="accounts"
                :customSave="saveGrid"
                :customLoad="loadGrid"
              />
              <DxHeaderFilter :visible="true" ref="headerFilter" />
              <DxSearchPanel
                :enabled="!hideActions"
                :width="240"
                placeholder="Search..."
              />
              <DxScrolling :useNative="true"></DxScrolling>
              <DxSorting mode="multiple"></DxSorting>
              <!-- <DxFilterPanel :visible="true" /> -->
              <DxColumn
                v-for="column in columns"
                :data-field="column.field"
                :caption="column.label"
                :data-type="column.type"
                :format="column.format"
                :cell-template="column.template"
                :visible="column.visible"
                :filter-type.sync="column.filterType"
                :filter-values.sync="column.filterValues"
                :filter-value.sync="column.filterValue"
                :width="column.width"
                :selected-filter-operation.sync="column.selectedFilterOperation"
                :header-filter="column.headerFilter"
                :alignment="column.alignment"
                :cssClass="column.cssClass"
                :sort-order="column.sortOrder"
                :sort-index="column.sortIndex"
                :group-index="column.groupIndex"
                :calculateSortValue="column.calculateSortValue"
                :allow-filtering="column.allowFiltering"
                ref="column"
              />
              <DxColumnChooser
                :enabled="!hideActions"
                :allow-search="true"
                mode="dragAndDrop"
              />
              <DxEditing
                v-if="allowEditing || allowDeleting"
                :allow-updating="allowEditing"
                :allow-deleting="allowDeleting"
                mode="row"
              />
              <DxSelection
                :mode="selectionEnabled ? 'multiple' : 'none'"
                showCheckBoxesMode="always"
              />
              <!-- <DxFilterPanel
                                :visible="true"
                                :filter-enabled="false"
                            /> -->
              <DxSummary v-if="summaryOptions && summaryOptions.enabled">
                <DxTotalItem
                  v-if="!summaryOptions.isNumber"
                  v-for="column in summaryOptions.columns"
                  :column="column"
                  summaryType="sum"
                  :valueFormat="getValueFormat(column)"
                  displayFormat="{0}"
                >
                </DxTotalItem>
                <DxTotalItem
                  v-if="summaryOptions.isNumber"
                  v-for="column in summaryOptions.columns"
                  :column="column"
                  summaryType="sum"
                  displayFormat="{0}"
                >
                </DxTotalItem>
                <DxGroupItem
                  v-if="summaryOptions.grouping"
                  v-for="column in summaryOptions.groupingSumColumns"
                  :show-in-group-footer="false"
                  :align-by-column="true"
                  :column="column"
                  :summary-type="getSummaryType(column)"
                  :valueFormat="getValueFormat(column)"
                  display-format="{0}"
                />
              </DxSummary>
              <DxMasterDetail
                :enabled="expandedOptions && expandedOptions.enabled"
                template="detailTemplate"
              />
              <template #detailTemplate="{ data }">
                <component
                  class="expanded-row"
                  v-if="expandedOptions"
                  :is="getTemplateName(data.data)"
                  :row="data.data"
                  :columns="columns"
                  :reloadGrid="reloadGrid"
                />
              </template>
              <template #link-cell-template="{ data }">
                <router-link
                  v-if="showLink(data)"
                  :to="{
                    name: getColumnLink(data).link,
                    params: {
                      id: getColumnLink(data).id,
                    },
                  }"
                  >{{ getColumnLink(data).text }}</router-link
                >
                <div v-else>
                  {{ data.value }}
                </div>
              </template>
              <template #link-action-cell-template="{ data }">
                <div v-if="!showLink || showLink(data)">
                  <a @click.stop="linkAction(data)" class="">{{
                    data.value
                  }}</a>
                </div>
                <div v-else>
                  {{ data.value }}
                </div>
              </template>

              <template #link-audio-cell-template="{ data }">
                <audio
                  v-if="data.value"
                  style="height: 25px;"
                  controls
                  :src="data.value"
                ></audio>
              </template>
              <template #audio-template="{ data }">
                <audio
                  style="height: 25px;"
                  ref="audioTemplate"
                  :src="audioURL"
                  controls
                ></audio>
              </template>
              <template #play-audio-cell-template="{ data }">
                <div>
                  <v-btn
                    class="ma-0"
                    style="height: 25px;"
                    @click.stop="playAudio(data.value)"
                    flat
                    icon
                    color="info"
                  >
                    <v-icon>mdi-play-circle</v-icon>
                  </v-btn>
                  <span>{{ getDurationText(data) }}</span>
                </div>
              </template>
              <template #play-button-cell-template="{ data }">
                <div>
                  <v-btn
                    class="ma-0"
                    style="height: 25px;"
                    @click.stop="playButtonClicked(data)"
                    flat
                    icon
                    color="info"
                  >
                    <v-icon>{{ getPlayIcon(data) }}</v-icon>
                  </v-btn>
                </div>
              </template>
              <template #utc-to-est-template="{ data }">
                {{ toEstTime(data.value) }}
              </template>
              <template #text-color-cell-template="{ data }">
                <div :style="{ color: getTextColor(data) }">
                  {{ data.value }}
                </div>
              </template>
              <template #reset-all-filters="{ data }">
                <v-btn
                  @click="resetAllFilters"
                  dark
                  class="mx-1"
                  small
                  color="default"
                >
                  Reset
                </v-btn>
              </template>
              <template #reload="{ data }">
                <v-btn
                  @click="reloadGrid"
                  dark
                  class="mx-1"
                  small
                  color="default"
                >
                  Reload
                </v-btn>
              </template>
              <template #action-button="{ data }">
                <button
                  class="dxgrid-action_buttons mx-1 "
                  v-if="showActionButton(data.text, data.name)"
                  @click="data.onItemClick()"
                  :loading="data.loading"
                  v-bind:class="{
                    'action-loading': actionsProcessing.includes(data.name),
                    'button-clicked': data.isButtonClicked(),
                  }"
                >
                  {{ data.getActionText() }}
                  <!-- <template slot="loader">
                                    <span>
                                        <v-layout row class="pl-2 pr-3 my-1">
                                            <v-icon
                                                class="custom-loader pr-2"
                                                light
                                                >mdi-cached</v-icon
                                            >
                                            <div class="mt-1">
                                                {{ data.text }}
                                            </div>
                                        </v-layout>
                                    </span>
                                </template> -->
                </button>
              </template>
              <template #action-select="{ data }">
                <v-select
                  hide-details
                  class="mb-0"
                  v-bind:class="{
                    'mx-1': hasMultipleSelectActions(),
                  }"
                  :style="{ width: data.options.width }"
                  style="margin-top: 7px; border-bottom: black 1px solid"
                  :items="data.options.items"
                  :clearable="data.options.clearable"
                  :multiple="data.options.multiple"
                  v-model="data.options.value"
                  @change="data.onItemClick"
                  :label="data.text"
                  :placeholder="data.options.placeholder"
                >
                  <template
                    v-if="data.options.multiple"
                    v-slot:selection="{ item, index }"
                  >
                    <span
                      v-if="index === 0 && data.options.value.length === 1"
                      >{{ item.text || item }}</span
                    >
                    <span v-else-if="index === 0"
                      >{{ data.options.value.length }} selected</span
                    >
                  </template>
                </v-select>
                <!-- <v-layout row>
                                    <div
                                        class="mr-2 ml-3 mb-0 pb-0"
                                        v-if="data.text"
                                        style="font-size: 15px !important"
                                    >
                                        {{ data.text }}
                                    </div>
                                    <DxSelectBox
                                        :items="data.options.items"
                                        :value.sync="data.options.value"
                                        @onValueChanged="data.onItemClick"
                                    />
                                </v-layout> -->
              </template>
              <template #action-datepicker="{ data }">
                <v-layout row>
                  <v-menu
                    class=""
                    v-model="data.datePickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        style="max-width: 120px;"
                        hide-details
                        class="mr-3"
                        v-model="data.options.value"
                        :value="data.options.value"
                        :label="data.text"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="data.options.value"
                      @change="data.onItemClick(data.options.value)"
                    ></v-date-picker>
                  </v-menu>
                </v-layout>
              </template>
              <template #action-text="{ data }">
                <div v-html="data.getText()"></div>
              </template>
              <template #action-input="{ data }">
                <v-text-field
                  style="max-width: 200px; border: 1px solid #4caf50;"
                  hide-details
                  class="mr-3"
                  v-model="data.options.value"
                  :value="data.options.value"
                  :label="data.text"
                  @input="data.onItemClick"
                  :clearable="data.options.clearable"
                  :mask="data.options.mask"
                ></v-text-field>
              </template>
              <template #action-options-menu="{ data }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn color="success" small dark v-on="on">
                      {{ data.text }}
                      <v-icon right dark>mdi-menu-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in data.options.items"
                      :key="index"
                      @click=""
                    >
                      <v-list-tile-title @click="data.onItemClick(item)"
                        >{{ item.text }}
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </template>

              <template #action-switch="{ data }">
                <v-switch
                  color="success"
                  class="mt-0"
                  @change="data.onItemClick"
                  :label="data.text"
                  v-model="data.value"
                  hide-details
                ></v-switch>
              </template>

              <template #action-menu="{ data }">
                <v-menu offset-y v-if="showActionButton(data.text, data.name)">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="success"
                      small
                      dark
                      v-on="on"
                      v-bind:class="{
                        'action-loading': actionsProcessing.includes(data.name),
                      }"
                    >
                      {{ data.text }}
                      <v-icon right dark>mdi-menu-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in data.options.items.filter(
                        (item) => showActionItem(item)
                      )"
                      :key="index"
                      @click=""
                    >
                      <v-list-tile-title @click="data.onItemClick(item.value)"
                        >{{ item.text }}
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </template>
              <template #filter-tags="{ data }">
                <div>
                  <v-chip
                    v-for="filter in columns.filter(hasFilter)"
                    @input="clearFilter(filter)"
                    close
                    ><div class="font-weight-medium">
                      {{ getFilterLabel(filter.field) }}
                    </div>
                    : {{ getFilterValue(filter) }}</v-chip
                  >
                </div>
              </template>
              <template #icon="{ data }">
                <v-icon class="px-0" dark :color="getIconColor(data)">{{
                  getIcon(data)
                }}</v-icon>
              </template>
            </DxDataGrid>
          </div>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxSearchPanel,
  DxFilterRow,
  DxExport,
  DxEditing,
  DxPaging,
  DxRemoteOperations,
  DxPager,
  DxStateStoring,
  DxColumnChooser,
  DxLoadPanel,
  DxMasterDetail,
  DxScrolling,
  DxSorting,
  DxSelection,
  DxFilterPanel,
  DxSummary,
  DxTotalItem,
  DxGroupItem,
  isRemotePaging,
  isRemoteSorting,
  DxFilterBuilderPopup,
  DxButton,
} from "devextreme-vue/data-grid";
import { DxFilterBuilderTypes } from "devextreme-vue/filter-builder";
import { formatCurrency, getDomain } from "../../utils/helpers.js";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import moment from "moment";
import { EdmLiteral } from "devextreme/data/odata/utils";
import DxSelectBox from "devextreme-vue/select-box";

export default {
  name: "dx-grid",
  props: {
    url: { type: String },
    name: { default: null, type: String },
    baseUrl: { type: String },
    title: { type: String },
    footerMessage: { type: String },
    headerMessage: { type: String },
    mapper: { default: null, type: [Function, String] },
    navigationPath: { default: null, type: String },
    navigationField: { default: null, type: String },
    hideActions: { default: false, type: Boolean },
    disableStoring: { default: false, type: Boolean },
    hideHeader: { default: false, type: Boolean },
    selectionEnabled: { default: false, type: Boolean },
    disableExporting: { default: false, type: Boolean },
    columns: {},
    exportColumns: {},
    actions: {},
    sortOptions: {},
    expandedOptions: {},
    summaryOptions: {},
    onRowClicked: { default: null, type: Function },
    onCellClicked: { default: null, type: Function },
    onCellPrepared: { default: null, type: Function },
    beforeSetupGrid: { default: null, type: Function },
    paginate: { default: false, type: Boolean },
    allowEditing: { default: false, type: Boolean },
    allowDeleting: { default: false, type: Boolean },
    onLoaded: { default: null, type: Function },
    onSelected: { default: null, type: Function },
    getCustomTitle: { default: null, type: Function },
    updateRow: { default: null, type: Function },
    deleteRow: { default: null, type: Function },
    freezeHeader: { default: false, type: Boolean },
    isRemotePaging: { default: true, type: Boolean },
    isRemoteSorting: { default: true, type: Boolean },
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxSearchPanel,
    DxFilterRow,
    DxExport,
    DxEditing,
    DxPaging,
    DxRemoteOperations,
    DxPager,
    DxStateStoring,
    DxColumnChooser,
    DxLoadPanel,
    DxFilterPanel,
    DxMasterDetail,
    DxScrolling,
    DxSorting,
    DxSelection,
    DxSummary,
    DxTotalItem,
    DxSelectBox,
    DxGroupItem,
    DxFilterBuilderPopup,
    DxButton,
  },
  data: () => ({
    pageSizes: [20, 100, 200, 1000],
    dataSource: {},
    dataSourceCopy: {},
    columnsCopy: [],
    grid: "",
    showGrid: false,
    pinHeader: false,

    actionsProcessing: [],
    responsive: false,
    audioURL: "",

    toolbarItems: [],

    filterBuilder: {
      customOperations: [],
      allowHierarchicalFields: true,
    },

    filterValue: [],

    filterOperaters: new Map([
      ["startswith", "Starts With"],
      ["endswith", "Ends with"],
      ["notcontains", "Not Contains"],
      ["contains", "Contains"],
      ["<>", "Do not equal"],
      ["=", "Equals"],
      ["<", "Less than"],
      [">", "Greater than"],
      ["<=", "Less than or equal to"],
      [">=", "Greater than or equal to"],
      ["between", "Between"],
    ]),

    calculateFilterExpression(filterValue, selectedFilterOperation) {
      // let column = this;
      // if(column.type == 'date') {
      //     console.log(column);
      // }
      // return column.defaultCalculateFilterExpression.apply(
      //     this,
      //     arguments
      // );
      const filter = this.defaultCalculateFilterExpression(
        filterValue,
        selectedFilterOperation
      );
      if (this.dataType == "date" && filter) {
        if (Array.isArray(filter[0])) {
          filter[0][2] = new EdmLiteral(filter[0][2].toISOString());
          filter[2][2] = new EdmLiteral(filter[2][2].toISOString());
        } else if (filter[2]) {
          filter[2] = new EdmLiteral(filter[2].toISOString());
        }
      }
      return filter;
    },
  }),
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  async created() {
    this.init();
  },
  computed: {
    pinHeaderIcon: {
      get() {
        return this.pinHeader ? "pin" : "pinleft";
      },
      // set(newValue) {
      //   const names = newValue.split(' ');
      //   this.firstName = names[0];
      //   this.lastName = names[names.length - 1];
      // }
    },
  },
  methods: {
    async init() {
      const pinHeader = localStorage.getItem("pin-header");

      this.pinHeader = !(!pinHeader || pinHeader == "false");

      if (this.beforeSetupGrid) {
        await this.beforeSetupGrid();
      }

      this.showGrid = true;

      this.setupGrid(this.url);
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    customizeText(cell) {
      return cell.value;
    },
    getFilterOperationValue(selectedFilterOperation) {
      if (!selectedFilterOperation) return "contains";

      return (
        this.filterOperaters.get(selectedFilterOperation) ||
        selectedFilterOperation
      );
    },
    setupDefaultFilters() {
      this.columns.filter(this.hasDefaultFilter).forEach((column) => {
        if (column.filterValue || column.filterValue === 0) {
          if (!this.filterValue.length) {
            this.filterValue = [
              column.field,
              column.selectedFilterOperation,
              column.filterValue,
            ];
          } else if (this.filterValue.length) {
            const filter = [
              this.filterValue,
              "and",
              [
                column.field,
                column.selectedFilterOperation,
                column.filterValue,
              ],
            ];

            this.filterValue = filter;
          }
        }

        if (column.filterValues && column.filterValues.length) {
          if (!this.filterValue.length) {
            this.filterValue = [column.field, "anyof", column.filterValues];
          } else if (this.filterValue.length) {
            const filter = [
              this.filterValue,
              "and",
              [column.field, "anyof", column.filterValues],
            ];

            this.filterValue = filter;
          }
        }
      });
    },
    hasDefaultFilter(column) {
      return (
        column.selectedFilterOperation ||
        column.filterValue ||
        (column.filterValues && column.filterValues.length)
      );
    },
    setupGrid() {
      this.columns.forEach((c) => (c.dataField = c.field));

      //this.setupDefaultFilters();

      this.columnsCopy = JSON.parse(JSON.stringify(this.columns));

      const baseUrl = this.baseUrl ? this.baseUrl : getDomain();

      const token = this.$store.state.authentication.token;

      const dataSource = new DataSource({
        store: new ODataStore({
          version: 4,
          url: baseUrl + "/odata/" + this.url,
          beforeSend: (e) => {
            e.timeout = 30000;
            e.headers = {
              Authorization: token,
            };
          },
          onLoaded: this.onResultsLoaded,
          errorHandler: (error) => {
            console.log(error);
            if (error.httpStatus == 401) {
              window.location.href = "/login";

              return;
            }
          },
        }),
        //paginate: this.paginate,
      });

      const dataSourceCopy = new DataSource({
        store: new ODataStore({
          version: 4,
          url: baseUrl + "/odata/" + this.url,
          beforeSend: (e) => {
            e.timeout = 30000;
            e.headers = {
              Authorization: token,
            };
          },
          onLoaded: this.onResultsLoaded,
          errorHandler: (error) => {
            console.log(error);
            if (error.httpStatus == 401) {
              window.location.href = "/login";

              return;
            }
          },
        }),
        //paginate: this.paginate,
      });

      this.dataSource = dataSource;
      this.dataSourceCopy = dataSourceCopy;
    },
    isLoading() {
      return (
        typeof this.dataSource.isLoading === "function" &&
        this.dataSource.isLoading()
      );
    },
    isLoaded() {
      return (
        typeof this.dataSource.isLoaded === "function" &&
        this.dataSource.isLoaded()
      );
    },
    async loadAll() {
      const response = await this.grid
        .getDataSource()
        .store()
        .load();

      // const url = this.url.split("?");

      // let state = localStorage.getItem(url[0]);

      // if (state) {
      //     state = JSON.parse(state);
      //     state.pageSize = 20;

      //     localStorage.setItem(url[0], JSON.stringify(state));
      // }

      return response;
    },
    getCustomTitleText() {
      if (this.getCustomTitle) {
        return this.getCustomTitle();
      }
    },
    getTemplateName(data) {
      if (this.expandedOptions && this.expandedOptions.enabled) {
        return this.expandedOptions.getTemplateName
          ? this.expandedOptions.getTemplateName(data)
          : this.expandedOptions.template;
      }
    },
    dateRangeFilter(column) {
      function formatDate(date) {
        return new Date(date).toISOString();
      }

      function handleBetween(column) {
        if (!Array.isArray(column.filterValue)) return "";

        const date = new Date(Date.parse(column.filterValue[0]));

        date.setHours(0, 0, 0, 0);

        const nextDay = new Date(Date.parse(column.filterValue[1]));

        nextDay.setHours(0, 0, 0, 0);

        return `((${column.field} ge ${date.toISOString()}) and (${
          column.field
        } lt ${nextDay.toISOString()}))`;
      }

      if (!column.filterValue) return "";

      if (
        !column.selectedFilterOperation ||
        column.selectedFilterOperation == "="
      ) {
        const date = new Date(Date.parse(column.filterValue));

        date.setHours(0, 0, 0, 0);

        const nextDay = new Date(Date.parse(column.filterValue));

        nextDay.setHours(0, 0, 0, 0);

        nextDay.setDate(nextDay.getDate() + 1);

        return `((${column.field} ge ${date.toISOString()}) and (${
          column.field
        } lt ${nextDay.toISOString()}))`;
      } else if (column.selectedFilterOperation == "between") {
        return handleBetween(column);
      } else {
        const date = new Date(Date.parse(column.filterValue));

        date.setHours(0, 0, 0, 0);

        const nextDay = new Date(Date.parse(column.filterValue));

        nextDay.setHours(0, 0, 0, 0);

        nextDay.setDate(nextDay.getDate() + 1);

        switch (column.selectedFilterOperation) {
          case ">":
            return `(${column.field} ge ${nextDay.toISOString()})`;
          case ">=":
            return `(${column.field} ge ${date.toISOString()})`;
          case "<=":
            return `(${column.field} lt ${nextDay.toISOString()})`;
          case "<":
            return `(${column.field} lt ${date.toISOString()})`;
          case "<>":
            return `((${column.field} lt ${date.toISOString()}) or (${
              column.field
            } ge ${nextDay.toISOString()}))`;
        }
      }
    },
    numberFilter(column) {
      if (column.filterValues && column.filterValues.length) {
        return `(${column.filterValues
          .map((v) => `(${column.field} eq ${v})`)
          .join(" or ")})`;
      }

      if (!column.filterValue) return "";

      if (
        !column.selectedFilterOperation ||
        column.selectedFilterOperation == "="
      ) {
        return `(${column.field} eq ${column.filterValue})`;
      } else {
        switch (column.selectedFilterOperation) {
          case ">":
            return `(${column.field} gt ${column.filterValue})`;
          case ">=":
            return `(${column.field} ge ${column.filterValue})`;
          case "<=":
            return `(${column.field} le ${column.filterValue})`;
          case "<":
            return `(${column.field} lt ${column.filterValue})`;
          case "<>":
            return `(${column.field} ne ${column.filterValue})`;
          case "between":
            return `((${column.field} ge ${column.filterValue[0]}) and (${
              column.field
            } lt ${column.filterValue[1]}))`;
        }
      }
    },
    parseFilter(filter) {
      const filters = [].concat.apply(
        [],
        this.columns
          .map((column) => {
            const name = column.field;
            const value = column.filterValue;
            const type = column.type;
            const filterValues = column.filterValues || [];

            if (["", undefined, null].includes(value) && !filterValues.length)
              return;

            if (type == "date") {
              return this.dateRangeFilter(column);
            }

            if (type == "number") {
              return this.numberFilter(column);
            }

            if (type == "boolean") {
              if (value == "true") {
                return `${name} eq ${value}`;
              }

              return `(${name} eq ${value})`;
            }

            if (filterValues.length) {
              return `(${filterValues
                .map((v) => `(tolower(${name}) eq '${v.toLowerCase()}')`)
                .join(" or ")})`;
            }

            if (column.selectedFilterOperation) {
              return `(${
                column.selectedFilterOperation
              }(tolower(${name}), '${value.toLowerCase()}'))`;
            }

            return `(contains(tolower(${name}), '${value.toLowerCase()}'))`;
          })
          .filter(Boolean)
      );

      return `${filters.join(" and ")}`;
    },
    getDataSourceURL() {
      const filter = this.grid.getCombinedFilter();

      const dataSource = this.grid.getDataSource();

      const parsedFilter = this.parseFilter(filter);

      let filterParams = parsedFilter ? "$filter=" + parsedFilter : "";

      let url = dataSource.store()._url;

      if (filterParams) {
        url =
          url + (url.includes("?") ? "&" + filterParams : "?" + filterParams);
      }

      return url;
    },
    async loadAllWithFilter() {
      const filter = this.grid.getCombinedFilter();

      const dataSource = this.grid.getDataSource();

      dataSource.filter(filter);

      dataSource.paginate(false);

      const response = await dataSource.load();

      const name = this.name ? this.name : this.url.split("?")[0];

      let state = await this.getState(name);

      if (state) {
        //state = JSON.parse(state);
        state.pageSize = 20;

        await this.setState(name, JSON.stringify(state));
      }

      return response;
    },
    customizeColumns(columns) {
      // const iconColumn = this.columns.find(c => c.isIcon);
      // if (iconColumn) {
      //     const column = columns.find(c => c.dataField == iconColumn.field);
      //     const index = columns.indexOf(column);
      //     columns[index].visibleIndex = 1;
      // }
    },
    calculte(v) {
      console.log(v);

      return 50;
    },
    getColumnLink(data) {
      const column = this.columns
        .filter((c) => !c.isIcon)
        .find((c) => c.field == data.column.dataField);

      return {
        link:
          typeof column.link === "function"
            ? column.link(data.data)
            : column.link,
        id: data.value ? data.value.toString().trim() : data.value,
        text: data.text,
      };
    },
    getIconColor(data) {
      const column = this.columns.find((c) => c.field == data.column.dataField);

      return column.iconColor(data.value, data.data);
    },
    getIcon(data) {
      const column = this.columns.find((c) => c.field == data.column.dataField);

      return column.icon(data.value, data.data);
    },
    allowExporting() {
      return !this.disableExporting;
    },
    buttonClick() {
      this.filterValue = this.filterValue;
    },
    async onRowRemoving(data) {
      data.cancel = true;

      if (this.deleteRow) await this.deleteRow(data.data);

      data.component.cancelEditData();

      this.reloadGrid();
    },
    async onRowUpdating(data) {
      if (!this.updateRow) return;

      data.cancel = true;

      await this.updateRow(data);

      data.component.cancelEditData();

      this.reloadGrid();
    },
    showLink(data) {
      const column = this.columns
        .filter((c) => !c.isIcon)
        .find((c) => c.field == data.column.dataField);

      if (!column.showLink) return true;

      return column.showLink(data.data);
    },
    linkAction(data) {
      const column = this.columns
        .filter((c) => !c.isIcon)
        .find((c) => c.field == data.column.dataField);

      return column.linkAction(data.data);
    },
    getTotalCount() {
      if (!this.dataSource || typeof this.dataSource.totalCount !== "function")
        return 0;

      const count =
        this.dataSource.totalCount() > 0 ? this.dataSource.totalCount() : 0;

      return count;
    },
    getTitle() {
      if (!this.dataSource || typeof this.dataSource.totalCount !== "function")
        return this.title;

      const count =
        this.dataSource.totalCount() > 0 ? this.dataSource.totalCount() : 0;

      return `${this.title} (${count})`;
    },
    onCellClick(event) {
      if (this.onCellClicked) {
        this.onCellClicked(event);

        return;
      }
    },
    onRowClick(event) {
      if (
        !this.navigationPath ||
        event.handled ||
        event.rowType == "detail" ||
        this.onCellClicked
      )
        return;

      if (this.onRowClicked) {
        this.onRowClicked(event.data, event);

        return;
      }

      this.$router.push({
        name: this.navigationPath,
        params: { id: event.data[this.navigationField] },
      });
    },
    startLoading() {
      this.$Progress.start();
    },
    finishLoading() {
      this.$Progress.finish();
    },
    saveGridInstance(e) {
      this.grid = e.component;
    },
    async saveGrid(state) {
      const name = this.name ? this.name : this.url.split("?")[0];

      await this.setState(name, JSON.stringify(state));
    },
    parseDateFilter(value, column) {
      if (!value) return value;

      if (column.type != "date") return value;

      return column.selectedFilterOperation == "between"
        ? value.map((v) => new Date(v))
        : new Date(value);
    },
    // isUsingDefaultFilters() {
    //     function getValues(value, column) {
    //         if (column.type == "date") {
    //             return Array.isArray(value)
    //                 ? value.map(v => new Date(v))
    //                 : new Date(value);
    //         }

    //         if (value && !value.length) return undefined;

    //         return value;
    //     }

    //     function getValue(value, column) {
    //         if (column.type == "date") {
    //             return Array.isArray(value)
    //                 ? value.map(v => new Date(v))
    //                 : new Date(value);
    //         }

    //         return value;
    //     }

    //     return this.columns.every(column => {
    //         const columnCopy = this.columnsCopy
    //             .filter(c => !c.isIcon)
    //             .find(c => c.field == column.field);

    //         if (
    //             getValue(column.filterValue, column) !=
    //                 getValue(columnCopy.filterValue, column) ||
    //             getValues(column.filterValues, column) !=
    //                 getValues(columnCopy.filterValues, column) ||
    //             column.selectedFilterOperation !=
    //                 columnCopy.selectedFilterOperation
    //         ) {
    //             console.log(columnCopy.field);
    //         }
    //         return (
    //             getValue(column.filterValue, column) ==
    //                 getValue(columnCopy.filterValue, column) &&
    //             getValues(column.filterValues, column) ==
    //                 getValues(columnCopy.filterValues, column) &&
    //             column.selectedFilterOperation ==
    //                 columnCopy.selectedFilterOperation
    //         );
    //     });
    // },
    async setStateOnServer(name, value) {
      try {
        await this.$http.post("api/adminPortal/save?", {
          userName: this.$store.state.authentication.user,
          dataTable: name,
          value: value,
          field: "AllColumns",
        });
      } catch (e) {}
    },
    async setState(name, value) {
      return await this.setStateOnServer(name, value);

      //return localStorage.setItem(name, value);
    },
    async loadStateFromServer(name) {
      try {
        const response = await this.$http.get(
          "api/adminPortal/get?userName=" +
            this.$store.state.authentication.user +
            "&table=" +
            name
        );

        if (!response) return;

        //const state = JSON.parse(response);

        const allColumns = response.find((r) => r.field == "AllColumns");

        if (!allColumns) return;

        const value = JSON.parse(allColumns.value);

        return value;
      } catch (e) {}
    },
    async getState(name) {
      return await this.loadStateFromServer(name);

      //return localStorage.getItem(name);
    },
    async loadGrid() {
      const name = this.name ? this.name : this.url.split("?")[0];

      let state = await this.getState(name);
      if (state) {
        //state = JSON.parse(state);
        state.columns.forEach((filter) => {
          const column = this.columns
            .filter((c) => !c.isIcon)
            .find((c) => c.field == filter.dataField);
          if (!column) return;

          column.selectedFilterOperation = this.hasValue(
            filter.selectedFilterOperation
          )
            ? filter.selectedFilterOperation
            : column.selectedFilterOperation;
          filter.selectedFilterOperation = column.selectedFilterOperation;

          column.filterValue = this.hasValue(filter.filterValue)
            ? this.parseDateFilter(filter.filterValue, column)
            : this.parseDateFilter(column.filterValue, column);
          filter.filterValue = this.parseDateFilter(column.filterValue, column);

          column.filterValues = this.hasValue(filter.filterValues)
            ? filter.filterValues
            : column.filterValues;
          filter.filterValues = column.filterValues;
        });

        this.handleIconColumn(state);
      }
      return state;
    },
    handleIconColumn(state) {
      const iconColumn = this.columns.find((c) => c.isIcon);

      if (!iconColumn) return;

      const stateIconColumn = state.columns.find(
        (s) => s.dataField == iconColumn.field
      );

      if (!stateIconColumn) return;

      const firstColumn = state.columns.find((c) => c.visibleIndex == 0);

      firstColumn.visibleIndex = 1;
      stateIconColumn.visibleIndex = 0;
    },
    clearFilter(filter) {
      const columns = this.columns.filter((c) => c.field == filter.field);

      columns.forEach((column) => {
        column.filterValue = null;
        column.filterValues = [];
        column.selectedFilterOperation = null;
      });
    },
    async removeFromServer(name) {
      try {
        await this.$http.post("api/adminPortal/delete?", {
          userName: this.$store.state.authentication.user,
          dataTable: name,
          field: "AllColumns",
        });
      } catch (e) {}
    },
    async resetAllFilters(filter) {
      const url = this.name ? this.name : this.url.split("?")[0];

      //localStorage.removeItem(url);

      await this.removeFromServer(url);

      location.reload();
      //this.init();
      // this.grid.clearFilter();

      // this.columns
      //     .filter((c) => !c.isIcon)
      //     .forEach((c) => (c.selectedFilterOperation = null));

      // this.resetDefaultFilters();
    },
    resetDefaultFilters() {
      this.columns.forEach((column) => {
        const columnCopy = this.columnsCopy
          .filter((c) => !c.isIcon)
          .find((c) => c.field == column.field);

        column.selectedFilterOperation = columnCopy.selectedFilterOperation;
        this.grid.columnOption(
          column.field,
          "selectedFilterOperation",
          column.selectedFilterOperation
        );
        column.filterValue = this.parseDateFilter(
          columnCopy.filterValue,
          columnCopy
        );
        this.grid.columnOption(column.field, "filterValue", column.filterValue);
        column.filterValues = columnCopy.filterValues;
        this.grid.columnOption(
          column.field,
          "filterValues",
          column.filterValues
        );
      });
    },
    hasFilter(column) {
      const has =
        this.hasValue(column.filterValue) ||
        (column.filterValues && column.filterValues.length);

      return has;
    },
    hasValue(value) {
      if (value === false) return true;
      if (value === 0) return true;

      return !!value;
    },
    getFilterLabel(field) {
      const column = this.columns
        .filter((c) => !c.isIcon)
        .find((c) => c.field == field);

      return column ? column.label : field;
    },
    getFilterOperation(filter) {
      return filter.selectedFilterOperation
        ? (this.filterOperaters.get(filter.selectedFilterOperation) ||
            filter.selectedFilterOperation) + ": "
        : "";
    },
    getFilterValue(filter) {
      const operation = this.getFilterOperation(filter);

      if (filter.type == "date") {
        if (filter.filterValues && filter.filterValues.length)
          return (
            "In: " +
            filter.filterValues
              .map((value) =>
                value ? moment(new Date(value)).format("L") : ""
              )
              .join(", ")
          );

        if (filter.selectedFilterOperation == "between") {
          return (
            operation +
            filter.filterValue.map((d) => moment(d).format("L")).join(" - ")
          );
        }

        return operation + moment(filter.filterValue).format("L");
      }

      if (filter.filterValues && filter.filterValues.length)
        return "In: " + filter.filterValues.join(", ");

      return operation + filter.filterValue;
    },
    getValueFormat(column) {
      const columnConfig = this.columns.find((c) => c.field == column);

      if (!columnConfig) return;

      if (columnConfig.type == "date") return;

      return columnConfig.format && columnConfig.format.type == "currency"
        ? "currency"
        : undefined;
    },
    getSummaryType(column) {
      const columnConfig = this.columns.find((c) => c.field == column);

      return columnConfig.groupIndex == 0 ? "count" : "sum";
    },
    playAudio(audio) {
      this.audioURL = audio;

      setTimeout(() => {
        if (this.$refs.audioTemplate) {
          const audioElement = this.$refs.audioTemplate;

          audioElement.style.display = "none";
          audioElement.offsetHeight; // Trigger reflow
          audioElement.style.display = "block";
          //audioElement.style.width = "100%"; // Ensure full width
          audioElement.style.overflow = "visible"; // Ensure controls are visible

          audioElement.play();
        }
      }, 0);
    },
    getDurationText(data) {
      const column = this.columns.find((c) => c.field == data.column.dataField);

      if (!data.data[column.durationColumn]) return;

      return moment
        .utc(
          moment
            .duration(data.data[column.durationColumn], "minutes")
            .asMilliseconds()
        )
        .format("mm:ss");
    },
    playButtonClicked(data) {
      const column = this.columns.find((c) => c.field == data.column.dataField);

      if (column && column.action) {
        column.action(data.data);
      }
    },
    getPlayIcon(data) {
      return data.data.playIcon;
    },
    hasMultipleSelectActions() {
      return this.actions.filter((a) => a.type == "select").length > 1;
    },
    onToolbarPreparing(e) {
      if (this.hideActions) return;

      const toolbarItems = [
        {
          location: "before",
          template: "filter-tags",
        },
        {
          location: "after",
          sortIndex: 0,
          template: "reset-all-filters",
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "pin",
            onClick: this.toggleHeader,
            hint: "Pin Header to Stay in Place",
            name: "pinHeaderButton",
          },
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            onClick: this.reloadGrid,
          },
        },
        // {
        //     location: "after",
        //     sortIndex: 1,
        //     template: "reload",
        // },
      ];

      if (this.actions) {
        let actionCount = 0;

        if (
          this.columns.some((c) => c.template == "play-audio-cell-template")
        ) {
          toolbarItems.splice(actionCount + 1, 0, {
            location: "after",
            visible: true,
            sortIndex: 2,
            template: "audio-template",
            onItemClick: (action) => {
              //play audio
            },
            text: this.audioURL,
            value: this.audioURL,
          });

          actionCount++;
        }

        if (this.responsive) {
          const buttonActions = this.actions.filter(
            (a) =>
              !a.isMenu &&
              a.type != "select" &&
              a.type != "datepicker" &&
              a.type != "text"
          );

          toolbarItems.splice(actionCount + 1, 0, {
            location: "after",
            visible: true,
            sortIndex: 1,
            template: "action-options-menu",
            text: "Options",
            name: "Options",
            onItemClick: (action) => {
              this.runAction(action);
            },
            options: {
              width: 200,
              items: buttonActions,
              displayExpr: "text",
              valueExpr: "value",
              value: "Options",
            },
          });
        }

        this.actions.forEach((action, index) => {
          if (action.isMenu) {
            toolbarItems.splice(actionCount + index + 1, 0, {
              location: "after",
              visible: true,
              sortIndex: 1,
              template: "action-menu",
              text: action.text,
              name: action.name ? action.name : action.text,
              onItemClick: (option) => {
                this.runMenuAction(action, option);
              },
              options: {
                width: 200,
                items: action.items,
                displayExpr: "text",
                valueExpr: "value",
                value: action.value,
              },
            });
          } else if (action.type == "select") {
            toolbarItems.splice(index + 1, 0, {
              location: action.align == "left" ? "before" : "after",
              visible: true,
              sortIndex: 1,
              template: "action-select",
              text: action.text,
              onItemClick: action.onSelected,
              options: {
                width: action.width ? action.width : "160px",
                items: action.values,
                clearable: action.clearable ? action.clearable : false,
                multiple: action.multiple ? action.multiple : false,
                displayExpr: "text",
                valueExpr: "value",
                value: action.value,
                placeholder: action.placeholder,
              },
            });
          } else if (action.type == "datepicker") {
            toolbarItems.splice(index + 1, 0, {
              location: action.align == "left" ? "before" : "after",
              visible: true,
              sortIndex: 1,
              template: "action-datepicker",
              datePickerMenu: false,
              text: action.text,
              onItemClick: action.action,
              options: {
                width: 200,
                items: action.values,
                displayExpr: "text",
                valueExpr: "value",
                value: action.value,
              },
            });
          } else if (action.type == "text") {
            toolbarItems.splice(index + 1, 0, {
              location: action.align == "left" ? "before" : "after",
              visible: true,
              sortIndex: 2,
              template: "action-text",
              text: action.text,
              getText() {
                return action.getText();
              },
            });
          } else if (action.type == "switch") {
            toolbarItems.splice(index + 1, 0, {
              location: action.align == "left" ? "before" : "after",
              visible: true,
              sortIndex: 1,
              template: "action-switch",
              text: action.text,
              value: action.value,
              onItemClick: action.action,
            });
          } else if (action.type == "input") {
            toolbarItems.splice(index + 1, 0, {
              location: action.align == "left" ? "before" : "after",
              visible: true,
              sortIndex: 2,
              template: "action-input",
              text: action.text,
              getText() {
                return action.getText();
              },
              onItemClick: action.onChanged,
              options: {
                width: 200,
                clearable: action.clearable ? action.clearable : false,
                displayExpr: "text",
                valueExpr: "value",
                inputType: action.inputType,
                mask: action.mask,
                value: action.value,
              },
            });
          } else {
            if (this.responsive) return;

            toolbarItems.splice(index + 1, 0, {
              onItemClick: () => {
                this.runAction(action);
              },
              loading: action.loading ? action.loading : false,
              location: "after",
              text: action.text,
              getActionText() {
                return action.text;
              },
              isButtonClicked() {
                return action.isButtonClicked
                  ? action.isButtonClicked()
                  : false;
              },
              visible: true,
              sortIndex: 1,
              name: action.name ? action.name : action.text,
              template: "action-button",
            });
          }
        });
      }

      e.toolbarOptions.items.unshift(...toolbarItems);

      this.toolbarItems = e.toolbarOptions.items;
    },
    runOnCellPrepared(e) {
      if (this.onCellPrepared) return this.onCellPrepared(e);
    },
    showActionButton(actionText, name) {
      const action = this.actions.find(
        (a) => a.text == actionText || a.name == name
      );

      return action.showOnSelection
        ? this.grid.getSelectedRowKeys().length
        : true;
    },
    showActionItem(action) {
      return action.showOnSelection
        ? this.grid.getSelectedRowKeys().length
        : true;
    },
    onSelectionChanged(e) {
      if (this.onSelected) {
        this.onSelected(this.getSelectedRowsData());
      }
    },
    customizeExportData(columns, rows) {
      rows.forEach(function(row) {
        let rowValues = row.values;
        for (let i = 0; i < rowValues.length; i++) {
          if (rowValues[i] == "") rowValues[i] = "";
          if (
            /[^\x20-\x7F]/.test(rowValues[i]) &&
            !/[\u0590-\u05FF]/.test(rowValues[i])
          ) {
            rowValues[i] = "";
          }
        }
      });
    },
    onExporting(e) {
      this.columns
        .filter((c) => c.shouldAlwaysExport)
        .forEach((exportColumn) => {
          e.component.beginUpdate();
          e.component.columnOption(exportColumn.dataField, "visible", true);
        });

      const column = this.columns.find((c) => c.isIcon);

      if (!column) return;

      e.component.beginUpdate();
      e.component.columnOption(column.field, "visible", false);
    },
    onExported(e) {
      this.columns
        .filter((c) => c.shouldAlwaysExport)
        .forEach((exportColumn) => {
          e.component.columnOption(
            exportColumn.dataField,
            "visible",
            exportColumn.visible
          );
          e.component.endUpdate();
        });

      const column = this.columns.find((c) => c.isIcon);

      if (!column) return;

      e.component.columnOption(column.field, "visible", true);
      e.component.endUpdate();
    },
    reloadGrid() {
      if (this.grid) {
        this.grid.refresh();
        //this.grid.option("dataSource", []);
        //this.grid.option("dataSource", this.dataSource);
      }
    },
    toggleHeader() {
      this.pinHeader = !this.pinHeader;

      localStorage.setItem("pin-header", this.pinHeader);

      //this.$forceUpdate();
    },
    clearData() {
      if (this.grid) {
        this.grid.option("dataSource", []);
      }
    },
    reloadDataSource(url) {
      const baseUrl = this.baseUrl ? this.baseUrl : getDomain();

      const token = this.$store.state.authentication.token;

      const dataSource = new DataSource({
        store: new ODataStore({
          version: 4,
          url: baseUrl + "/odata/" + url,
          beforeSend: (e) => {
            e.timeout = 30000;
            e.headers = {
              Authorization: token,
            };
          },
          onLoaded: this.onResultsLoaded,
          errorHandler: (error) => {
            console.log(error);
            if (error.httpStatus == 401) {
              window.location.href = "/login";

              return;
            }
          },
        }),
        //paginate: this.paginate,
      });

      this.dataSource = dataSource;
    },
    getSelectedRowKeys() {
      return this.grid.getSelectedRowKeys();
    },
    getSelectedRowsData() {
      if (!this.grid) return;

      return this.grid.getSelectedRowsData();
    },
    onGridLoaded() {
      this.grid.clearSelection();
      this.grid.deselectAll();
    },
    clearSelection() {
      this.grid.clearSelection();
      this.grid.deselectAll();
    },
    toEstTime(date) {
      return moment(date)
        .subtract(4, "hours")
        .format("MM/DD/YYYY h:mm:ss A");
    },
    getTextColor(data) {
      const column = this.columns.find((c) => c.field == data.column.dataField);

      if (!column.getTextColor) return "";

      return column.getTextColor(data.value, data.data);
    },
    updateFilterValue() {
      this.filterValue = this.filterValue.map((filter) => {
        if (Array.isArray(filter)) {
          if (filter[1] === undefined || filter[1] === null) {
            filter[1] = "contains";
          }
        } else {
          if (filter === undefined || filter === null) {
            filter = "contains";
          }
        }

        return filter;
      });
    },
    onResultsLoaded(result) {
      //this.updateFilterValue();

      if (this.onLoaded) {
        this.onLoaded(result);
      }
    },
    async runMenuAction(action, option) {
      if (action.name) {
        this.actionsProcessing.push(action.name);
      }

      try {
        await action.action(option);
      } catch (e) {
        if (action.name) {
          const index = this.actionsProcessing.indexOf(action.name);

          this.actionsProcessing.splice(index, 1);
        }
      }

      if (action.name) {
        const index = this.actionsProcessing.indexOf(action.name);

        this.actionsProcessing.splice(index, 1);
      }
    },
    async runAction(action) {
      if (action.name) {
        this.actionsProcessing.push(action.name);
      }

      try {
        await action.action(this.grid.getSelectedRowKeys());
      } catch (e) {
        if (action.name) {
          const index = this.actionsProcessing.indexOf(action.name);

          this.actionsProcessing.splice(index, 1);
        }
      }

      if (action.name) {
        const index = this.actionsProcessing.indexOf(action.name);

        this.actionsProcessing.splice(index, 1);
      }
    },
  },
};
</script>
<style>
.filter-container {
  background-color: transparent;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.14), 0 0 2px 0 rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  padding: 5px;
  width: 500px;
  margin: 24px;
}

.dx-filterbuilder {
  background-color: transparent;
  padding: 10px;
}

.dxgrid-custom {
  font-weight: normal !important;
  font-size: 14px !important;
  font-family: "Helvetica Neue", "Segoe UI", Helvetica, Verdana, sans-serif !important;
}

.dxgrid-custom tr:nth-child(even) {
  background-color: rgba(51, 68, 109, 0.03);
}

/*.strikeout-red {
    content: " " !important;
    position: absolute !important;
    top: 50% !important;
    left: 0 !important;
    color: red !important;
    background-color: red !important;
    border-bottom: 1px solid red !important;
    width: 100% !important;
}*/
.dxgrid-clickable tr {
  cursor: pointer;
}
.dxgrid-custom .dx-datagrid .dx-row > td {
  font-size: 16px;
  /*color: black;*/
  /*    text-align: left !important;*/
  padding: 0.75em 0.75em 0.75em 0.75em;
}
.dxgrid-custom .dx-datagrid .dx-column-lines > td {
  /*border-left: unset !important;
    border-right: unset !important;*/
}
.dxgrid-custom .dx-datagrid-focus-overlay {
  border: 2px solid #5cb860;
}
.dxgrid-custom .dx-datagrid-search-text {
  color: #fff;
  background-color: #5cb860;
}

.dxgrid-custom
  .dx-scrollable-customizable-scrollbars
  ::-webkit-scrollbar:horizontal {
  height: 14px !important;
  background: #f1f1f1 !important;
}

.dxgrid-custom
  .dx-scrollable-customizable-scrollbars
  .dx-scrollable-container::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
}

.dxgrid-custom
  .dx-scrollable-customizable-scrollbars::-webkit-scrollbar-corner {
  background: #d2d2d2;
}

.reset-filter-button .dx-button-content {
  background-color: #999 !important;
  color: #fff !important;
  text-transform: uppercase !important;
}

.expanded-row td {
  padding: 0 !important;
  background-color: #fff !important;
}

.dxgrid-custom .dx-checkbox-checked .dx-checkbox-icon {
  color: #5cb860 !important;
}
.dxgrid-custom .dx-checkbox-indeterminate .dx-checkbox-icon {
  color: #5cb860 !important;
}

.dxgrid-custom .dx-checkbox-checked .dx-checkbox-icon {
  color: #5cb860 !important;
}

/*.dxgrid-action_buttons .v-btn.v-btn--icon {
    width: 41px;
    height: 30px !important;
    line-height: 30px !important;
}*/

.dxgrid-action_buttons {
  margin: 10px 1px;
  font-weight: 400 !important;
  height: auto;
  line-height: 1.5em;
  cursor: pointer;
  border-radius: 3px;
  box-shadow: 0 2px 2px 0 rgba(76, 175, 80, 0.14),
    0 3px 1px -2px rgba(76, 175, 80, 0.2), 0 1px 5px 0 rgba(76, 175, 80, 0.12) !important;
  text-transform: uppercase;
  padding: 0.40625rem 1.25rem !important;
  font-size: 11px;
  color: #fff;
  background-color: #5cb860 !important;
}

.v-btn--loader.v-btn__content {
  display: none;
}

.freeze-header {
  height: 850px !important;
}

.custom-loader {
  animation: loader 1s infinite;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.action-loading {
  background: #dddddd !important;
  color: black !important;
  border: none !important;
  pointer-events: none !important;
  cursor: none !important;
}
.button-clicked {
  background: #dddddd !important;
  color: black !important;
  border: none !important;
}
</style>
